import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { AuthContext } from '../../context/AuthContext';
import useAIChat from '../../hooks/useAIChat';
import ChatMessageList from './ChatMessageList';
import ChatInput from './ChatInput';
import './AIChat.css';

const AIChat = () => {
  const { user } = useContext(AuthContext);
  const { messages, sendMessage, loading, error, clearChat } = useAIChat();

  const isDisabled = !user;

  return (
    <div className="ai-chat-container">
      {/* Header */}
      <div className="ai-chat-header">
        <div>
          <h5>🤖 AI Financial Assistant</h5>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          {messages.length > 0 && (
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={clearChat}
              title="Clear conversation"
            >
              Clear
            </Button>
          )}
          <span className="ai-chat-powered-by">Powered by Gemini</span>
        </div>
      </div>

      {/* Error Banner */}
      {error && (
        <div className="chat-error-banner">
          ⚠️ {error}
        </div>
      )}

      {/* Message List */}
      <ChatMessageList messages={messages} loading={loading} />

      {/* Input */}
      <ChatInput
        onSend={sendMessage}
        loading={loading}
        disabled={isDisabled}
      />
    </div>
  );
};

export default AIChat;
